import { configureStore } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-extraneous-dependencies
import { setAutoFreeze } from 'immer';
import authReducer from './slices/authSlice';
import chatReducer from './slices/chatSlice';

setAutoFreeze(false);

// ----------------------------------------------------------------------

export const store = configureStore({
  reducer: {
    auth: authReducer,
    chat: chatReducer,
    // Add other reducers here as needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});
